module.exports = __webpack_public_path__ + "img/1584398955.bc0d24a6.jpg";